import React, { useState, useEffect, useRef } from "react";
import { ChevronUp, MessageSquare } from "lucide-react";

const ScrollToTopButton = () => {
  const [isVisible, setIsVisible] = useState(false);
  const footerRef = useRef(null);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    const handleScroll = () => {
      toggleVisibility();
      if (footerRef.current) {
        const footerTop = footerRef.current.getBoundingClientRect().top;
        const buttonElement = document.querySelector(".scroll-to-top-button");
        if (buttonElement) {
          if (footerTop <= window.innerHeight) {
            const bottomPosition = window.innerHeight - footerTop;
            buttonElement.style.bottom = `${bottomPosition + 16}px`;
          } else {
            buttonElement.style.bottom = "16px";
          }
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    footerRef.current = document.querySelector("footer");

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const openFeedback = () => {
    window.open(
      "https://us17.list-manage.com/survey?u=70f983b3c61c7194b8c97bbc0&id=2bd234bb5c",
      "_blank"
    );
  };

  return (
    <>
      {isVisible && (
        <div className="fixed right-4 bottom-4 flex flex-col gap-2 scroll-to-top-button z-50">
          <div className="relative group">
            <button
              className="p-3 rounded-full bg-transparent border border-white text-white"
              onClick={openFeedback}
            >
              <MessageSquare className="h-8 w-8" />
            </button>
            <div className="absolute bottom-full mr-2 left-1/2 transform -translate-x-1/2 opacity-0 group-hover:opacity-100 transition-opacity duration-200">
              <div className="p-2 bg-transparent text-white rounded-md">
                Feedback
              </div>
            </div>
          </div>

          <button
            className="p-3 rounded-full bg-white text-black border"
            onClick={scrollToTop}
          >
            <ChevronUp className="h-10 w-10" />
          </button>
        </div>
      )}
    </>
  );
};

export default ScrollToTopButton;
